import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import TooltipSection from '../TooltipSection';

export const MobileInventoryTargetingTooltip = () => (
    <TooltipSection>
        <FormattedMessage
            id="campaign.targeting.platform.mobile.inventory.tooltip"
            defaultMessage="Select ‘All’ for all devices, ‘Mobile Web only’ for mobile browsers, or ‘Mobile Apps only’ for in-app traffic."
        />
    </TooltipSection>
);
